import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';

export function parseAndDecodeCookieAccessToken(
  cookieService: CookieService,
  jwtHelper: JwtHelperService
): any {
  try {
    const userInfo = cookieService.get('HIT-user');
    if (userInfo) {
      const parsedUserInfo = JSON.parse(userInfo);
      return jwtHelper.decodeToken(parsedUserInfo.access_token);
    }
  } catch (error) {
    console.error('Error parsing or decoding access token:', error);
  }
  return null;
}

